import { useZodForm } from '@/hooks/use-zod-form';
import { useRequestProject } from '../hooks/use-request-project.mutation';
import {
  requestProjectValidationSchema,
  type RequestProjectFormFields,
} from './request-project-validation-schema';

export const useRequestProjectForm = () => {
  const { submitRequest, isLoading, isSuccess } = useRequestProject();

  const methods = useZodForm({
    schema: requestProjectValidationSchema,
    mode: 'onChange',
    defaultValues: {
      name: '',
      email: '',
      businessUnit: '',
      description: '',
    },
  });

  const onSubmit = async (data: RequestProjectFormFields) => {
    try {
      await submitRequest(data);
    } catch (error) {
      console.error('Failed to submit request:', error);
    }
  };

  return {
    methods,
    handleRequestProjectSubmit: methods.handleSubmit(onSubmit),
    isSubmitting: isLoading,
    isSuccess,
  };
};
